import { FC } from "react";
import { Select, InputSize, Show, type Option } from "shared/components";
import { SVGComponentProps } from "untitledui-js-base";

interface Props {
  id: string;
  title: string;
  Icon: FC<SVGComponentProps>;
  options: Option[];
  disabled?: boolean;
  defaultValue?: number | string;
  onSelect?: (value: number) => void;
}

export const DocumentItem: FC<Props> = ({
  id,
  Icon,
  options,
  title,
  disabled = false,
  defaultValue,
  onSelect = () => {}
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-[10px]">
        <Show if={Boolean(Icon)}>
          <Icon className="stroke-content-200" size="24" />
        </Show>
        <p className="text-sm text-content-500 font-medium">{title}</p>
      </div>
      <Select
        defaultValue={defaultValue}
        isDisabled={disabled}
        className="w-[173px]"
        id={id}
        onChange={(e) => {
          onSelect(Number(e.target.value));
        }}
        size={InputSize.SM}
        options={options}
        styles={{
          menu: (defaultStyles) => ({
            ...defaultStyles,
            width: 281,
            right: 0
          }),
          menuList: (defaultStyles) => ({
            ...defaultStyles,
            borderRadius: 6,
            padding: 0
          }),
          option: (defaultStyles, { isFocused }) => ({
            ...defaultStyles,
            paddingY: 10,
            paddingX: 16,
            cursor: "pointer",
            color: "#000",
            backgroundColor: isFocused ? "#1C1D220A" : "#fff",
            borderBottom: "1px solid #1C1D220A",
            ":last-child": {
              borderBottom: "none"
            }
          })
        }}
      />
    </div>
  );
};
